import React from 'react';
import { ParticipantStep } from '../../../../../../types/v3Types';
import { StepsListAsTiles } from '../../../components/StepsListAsTiles';
import { isSelfPaced } from '../../../../../../selectors/isSelfPaced';
import { Props } from '../interfaces';

export interface StepsListProps {
  props: Props;
  currentStep: ParticipantStep | null;
  onStepChosen: (step: ParticipantStep) => void;
}

export const StepsList: React.FC<StepsListProps> = ({
  props,
  currentStep,
  onStepChosen
}) => {
  const {
    challengeData: { challenge },
    participantSteps: { steps } = { steps: [] },
    isParticipantStepsLoading,
  } = props;

  if (isParticipantStepsLoading) {
    return null;
  }

  return (
    <StepsListAsTiles
      steps={steps}
      isSPC={isSelfPaced(challenge)}
      currentStepId={currentStep?.id}
      onStepChosen={onStepChosen}
    />
  );
};
